import React, {Fragment} from 'react';
import {Helmet} from "react-helmet";
import LayoutDefault from "layouts/LayoutDefault";
import Header from "components/header/HeaderEight";
import Breadcrumb from "components/breadcrumb/BreadcrumbOne";
import breadcrumbBg from "assets/img/bg/bg-image-54.jpg";
import ContactInfo from "container/contact/ContactInfoOne";
import ContactForm from "container/contact/ContactFive";
import Footer from "container/footer/FooterFour";

const ContactClassic = () => {
    return (
        <Fragment>
            <Helmet>
                <title>Contact Us || Brook - React JS Creative Multipurpose Template</title>
            </Helmet>

            <LayoutDefault className="template-color-1 template-font-1">
                <Header/>
                <ContactForm/>
                <ContactInfo/>
                <Breadcrumb title="¿Tienes una idea que quieras impulsar?" />
                <Footer full={false}/>
            </LayoutDefault>
        </Fragment>
    );
};

export default ContactClassic;